import axios from 'axios'
import {message, Modal, notification} from 'ant-design-vue'
import moment from 'moment'
import store from '../store'
import db from 'utils/localstorage'
import { apiBaseUrl } from '../settings'
moment.locale('zh-cn')

let NFS_REQUEST = axios.create({
  baseURL: apiBaseUrl,
  responseType: 'json',
  validateStatus (status) {
    // 200 外的状态码都认定为失败
    return status === 200
  }
})

// 拦截请求
NFS_REQUEST.interceptors.request.use((config) => {
  let expireTime = store.state.account.expireTime
  let now = moment().format('YYYYMMDDHHmmss')
  // 让token早10秒种过期，提升“请重新登录”弹窗体验
  if (!config.headers.ignoreExpireTimeFlag && now - expireTime >= -10) {
    Modal.error({
      title: '登录已过期',
      content: '很抱歉，登录已过期，请重新登录',
      okText: '重新登录',
      mask: false,
      onOk: () => {
        return new Promise((resolve, reject) => {
          db.clear()
          location.reload()
        })
      }
    })
  }
  // 有 token就带上
  if (store.state.account.token) {
    config.headers.NFSAuthentication = store.state.account.token
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

// 拦截响应
NFS_REQUEST.interceptors.response.use((config) => {
  return config
}, (error) => {
  if (error.response) {
    let errorMessage = ''
    if (error.response.config.responseType === 'blob') {
      let reader = new FileReader()
      reader.readAsText(error.response.data)
      reader.onload = () => {
        errorMessage = reader === null ? '系统内部异常，请联系网站管理员' : JSON.parse(reader.result).message
        notifyErrorMessage(error.response.status, errorMessage)
      }
    } else {
      errorMessage = error.response.data === null ? '系统内部异常，请联系网站管理员' : error.response.data.message
      notifyErrorMessage(error.response.status, errorMessage)
    }
  }
  return Promise.reject(error) // 异步通知错误
})

let notifyErrorMessage = (status, errorMessage) => {
  switch (status) {
    case 404:
      notification.error({
        message: '系统提示',
        description: '很抱歉，资源未找到',
        duration: 4
      })
      break
    case 403:
    case 401:
      notification.warn({
        message: '系统提示',
        description: '很抱歉，您无法访问该资源，可能是因为没有相应权限或者登录已失效',
        duration: 4
      })
      break
    default:
      notification.error({
        message: '系统提示',
        description: errorMessage,
        duration: 4
      })
      break
  }
}

const request = {
  post (url, params, ignoreExpireTimeFlag) {
    return NFS_REQUEST.post(url, params, {
      headers: {
        'Content-Type': 'application/json',
        'ignoreExpireTimeFlag': ignoreExpireTimeFlag === true
      }
    })
  },
  get (url, ignoreExpireTimeFlag) {
    return NFS_REQUEST.get(`${url}`, {
      headers: {
        'ignoreExpireTimeFlag': ignoreExpireTimeFlag === true
      }
    })
  },
  export (url, params = {}) {
    message.loading('导出数据中')
    return NFS_REQUEST.post(url, params, {
      headers: {
        'Content-Type': 'application/json'
      },
      responseType: 'blob'
    }).then((r) => {
      const content = r.data
      const blob = new Blob([content])
      let fileName = `导出结果_${new Date().getTime()}.xlsx`
      if (r.headers['content-disposition'] && r.headers['content-disposition'].indexOf('filename') !== -1) {
        fileName = decodeURI(r.headers['content-disposition'].split(';').filter(e => e.indexOf('filename') !== -1)[0].split('=')[1])
      }
      if ('download' in document.createElement('a')) {
        const elink = document.createElement('a')
        elink.download = fileName
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href)
        document.body.removeChild(elink)
      } else {
        navigator.msSaveBlob(blob, fileName)
      }
    }).catch((r) => {
      console.error(r.response.data)
      message.error('导出失败')
    })
  },
  download (url, params, filename) {
    message.loading('文件传输中')
    return NFS_REQUEST.post(url, params, {
      headers: {
        'Content-Type': 'application/json'
      },
      responseType: 'blob'
    }).then((r) => {
      const content = r.data
      const blob = new Blob([content])
      if ('download' in document.createElement('a')) {
        const elink = document.createElement('a')
        elink.download = filename
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href)
        document.body.removeChild(elink)
      } else {
        navigator.msSaveBlob(blob, filename)
      }
    }).catch((r) => {
      console.error(r)
      message.error('下载失败')
    })
  },
  upload (url, params) {
    return NFS_REQUEST.post(url, params, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}

export default request



// WEBPACK FOOTER //
// ./src/utils/request.js